import { useRootStore } from '../hooks/useRootStore';

// Returns { rootStore } to match the shape all callers expect:
//   const rootStore = useStores()
export default function useStores() {
    return useRootStore();
}
